import { InformationDialogService } from '@sharedComponents/dialogs/information-dialog/information-dialog.service';
import { TolgeeService } from '@core/translation/tolgee.service';
import { environment } from '@env/environment';
import { BcmTenantPermission } from '@modules/bcm/bcm-tenant-permission';
import { BcmUserPermission } from '@modules/bcm/bcm-user-permission';
import { TableHeaderAction } from '@modules/bcm/@core/state-management/bcm-base.types';

export interface FilteredListExportPermissionCheck {
    checkPermission(permission: BcmTenantPermission): boolean;
}

export interface FilteredListExportUserPermissionCheck {
    hasAllPermissionsOf(...permissions: (BcmUserPermission | string)[]): boolean;
}

export function openFilteredListExportSalesDialog(informationDialogService: InformationDialogService): void {
    const bcm = environment.bcm;

    informationDialogService
        .useWarnTheme()
        .setTitle(TolgeeService.translate('table.filteredListExport.license.upgradeTitle'))
        .setBody(TolgeeService.translate('table.filteredListExport.license.upgradeBody', {
            supportMail: bcm.supportMail,
            supportPhone: bcm.supportPhone,
            supportPhoneBeautified: bcm.supportPhoneBeautified,
        }))
        .setTheme('warn')
        .setButton({ text: TolgeeService.translate('common.close'), color: 'warn' })
        .setDialogConfig({ panelClass: 'wider-dialog' })
        .open();
}

export function filteredListExportHeaderActionBase(): Pick<TableHeaderAction, 'tenantPermissionsUpsell' | 'userPermissions'> {
    return {
        tenantPermissionsUpsell: [BcmTenantPermission.FILTERED_LIST_EXPORT],
        userPermissions: [BcmUserPermission.EXPORT_FILTERED_VIEW],
    };
}

/**
 * Sichtbarkeit für „Aktuelle Ansicht exportieren“ (#6574):
 * - Mandant ohne Modulrecht → immer sichtbar (Klick → Vertriebs-Dialog)
 * - Mandant mit Modulrecht, Nutzer ohne Recht → ausgeblendet
 * - Beides vorhanden → sichtbar (Export)
 */
export function shouldShowFilteredListExportHeaderAction(
    tenantService: FilteredListExportPermissionCheck,
    userService: FilteredListExportUserPermissionCheck,
    item: Pick<TableHeaderAction, 'tenantPermissionsUpsell' | 'userPermissions'>,
): boolean {
    const modulePermissions = item.tenantPermissionsUpsell ?? [];
    const userPermissions = item.userPermissions ?? [];

    if (!modulePermissions.length) {
        return true;
    }

    const tenantHasModule = modulePermissions.every(permission => tenantService.checkPermission(permission));
    if (!tenantHasModule) {
        return true;
    }

    if (!userPermissions.length) {
        return true;
    }

    return userService.hasAllPermissionsOf(...userPermissions);
}

export function predefinedReportsExcelHeaderActionBase(): Pick<TableHeaderAction, 'tenantPermissions' | 'userPermissions'> {
    return {
        tenantPermissions: [BcmTenantPermission.REPORTS],
        userPermissions: [BcmUserPermission.DOWNLOAD_REPORTS],
    };
}
